import { inject, Injectable } from '@angular/core';
import { WebSocketService } from './web-socket.service';
import { AuthService } from './auth.service';
import { TopicType } from '../enums/topic-type';

@Injectable({
  providedIn: 'root',
})
export class UserBreakService {
  private webSocketService = inject(WebSocketService);
  private authService = inject(AuthService);

  sendUserUpdate(status: string) {
    const userId = this.authService.user().id;
    let uuid = this.authService.uuid;
    const message: object = {
      message: JSON.stringify({
        data: {
          availabilityStatus: status,
        },

        key: uuid,
        requester: userId,
        userId: userId,
      }),
    };

    this.webSocketService.send({
      topic: TopicType.USER_UPDATE_REQUEST,
      message,
    });
  }
}
